import { mobileDevice } from '@bingads-webui-campaign-react/common-hooks';

export const getFloatingBannerStyle = () => ({
  floatingBanner: {
    position: 'fixed',
    bottom: '10%',
    left: '50%',
    transform: 'translate(-50%, 0)',
    background: '#fff',
    width: 650,
    zIndex: 10000000,
    [mobileDevice]: {
      width: '100%',
    },
  },
});
